import { render, staticRenderFns } from "./addApprover.vue?vue&type=template&id=088a75f4&scoped=true&"
import script from "./addApprover.vue?vue&type=script&lang=js&"
export * from "./addApprover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088a75f4",
  null
  
)

export default component.exports